import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingScreen from "../screens/LandingScreen/LandingScreen";
import AlertsScreen from "../screens/AlertsScreen/AlertsScreen";
import MapScreen from "../screens/mapScreen/MapScreen";
import LoginScreen from "../screens/loginScreen/LoginScreen";
import MentionsLegales from "../screens/MentionsLegales/MentionsLegales";
import UnsubscribeScreen from "../screens/UnsubscribeScreen/UnsubscribeScreen";
import usePageTracking from "../hooks/usePageTracking";


const AppRoutes = () => {
  usePageTracking(); //inside Router context, tracks every navigation

  return (
    <Routes>
      <Route path="/" element={<LandingScreen />} />
      <Route path="/notifications" element={<MapScreen />} />
      <Route path="/register/" element={<LoginScreen />} />
      <Route path="/unsubscribe" element={<UnsubscribeScreen />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
    </Routes>
  );
};

const MainRoute = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </HelmetProvider>
);

export default MainRoute;